"use client"

import { useState } from "react"
import { useNavigate } from "react-router"
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import { Bell } from "lucide-react"
import { NotificationsModal } from "@/components/ui/notifications/notifications-modal"

interface CareerPathHeaderProps {
  userName?: string
  userImage?: string
}

export function CareerPathHeader({
  userName = "Alex",
  userImage = "https://lh3.googleusercontent.com/aida-public/AB6AXuAP2IiilWTL7sYfaHC6f20lt80HWF5zy7wzjn57r_VwIRz3Xl7qOoXe0oiEEZul6D87xahTP6SCyToMaFsXO7opd5D5av90GtKoTIWylvvENjo-Di9JKBF-QvOSkvruPrbbs34ZD5L8MZhic2hFyL_3jmZuK8ucS3wetCcs6pmhdBhXuUjtfL8HpQ9hOTrAehsxTuJOEKwGaGm4bB1z1gnVUd4UKW8-PzBTrtgURBkR7S6RwYh8n1pAkbXMV1HmDgglEjb_ECpVqxk",
}: CareerPathHeaderProps) {
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)
  const navigate = useNavigate()

  // Mock function to handle marking notifications as read
  const handleMarkAsRead = (notificationId: string) => {
    console.log("Marking notification as read:", notificationId)
    // Implement your logic to mark notification as read
  }

  const handleMarkAllAsRead = () => {
    console.log("Marking all notifications as read")
    // Implement your logic to mark all notifications as read
  }

  const handleAvatarClick = () => {
    navigate("/profile")
  }

  return (
    <>
      <header className="sticky top-0 z-10 w-full border-b border-slate-200 bg-transparent backdrop-blur-sm">
        <div className="container mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
          {/* Navigation - Hidden on mobile */}
          <nav className="hidden items-center gap-8 md:flex">
            {/* Navigation items can be added here if needed */}
          </nav>

          {/* Right Section - Notifications and Avatar */}
          <div className="flex items-center gap-3">
            {/* Notifications Bell */}
            <button
              onClick={() => setIsNotificationsOpen(true)}
              className="relative p-2 rounded-full hover:bg-slate-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              aria-label="View notifications"
            >
              <Bell className="w-6 h-6 text-slate-700 hover:text-blue-600 transition-colors" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
            </button>

            {/* Avatar with click handler */}
            <button
              onClick={handleAvatarClick}
              className="transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-full"
              aria-label="Go to profile"
            >
              <Avatar className="w-10 h-10 border-2 border-blue-600 cursor-pointer">
                <AvatarImage src={userImage || "/placeholder.svg"} alt={userName} />
                <AvatarFallback className="bg-blue-100 text-blue-700 font-semibold">
                  {userName.charAt(0).toUpperCase()}
                </AvatarFallback>
              </Avatar>
            </button>
          </div>
        </div>
      </header>

      {/* Notifications Modal */}
      <NotificationsModal
        isOpen={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
        onMarkAsRead={handleMarkAsRead}
        onMarkAllAsRead={handleMarkAllAsRead}
        position="top-right"
      />
    </>
  )
}